import React from 'react'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import { slugify } from '@helpers/string-helper'
import BaseCollectionTile from './BaseCollectionTile/BaseCollectionTile'

const CollectionTileV2 = ({ collection, featuredSlots = [], slotOrder = [] }) => (
  <Box
    id={slugify(collection?.collection)}
    sx={{
      scrollMarginTop: {
        xs: '50px',
        lg: '140px',
      },
    }}
  >
    <BaseCollectionTile collection={collection} featuredSlots={featuredSlots} slotOrder={slotOrder}>
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
        }}
        width="100%"
        role="article"
        aria-label={`${collection?.title || 'Collection'}`}
        data-testid={`collection-tile-${slugify(collection?.title)}`}
      >
        <Box width="60%" role="region" aria-label="Collection image gallery">
          <BaseCollectionTile.ImageGallery />
        </Box>

        <Box
          position="relative"
          width="40%"
          paddingLeft="16px"
          role="region"
          aria-label="Collection details"
          display="flex"
          gap="16px"
          flexDirection="column"
        >
          <Box display="flex" flexDirection="column" gap="4px">
            <BaseCollectionTile.Title />
            <BaseCollectionTile.Description />
            <BaseCollectionTile.PriceRange />
          </Box>
          <BaseCollectionTile.RoomOptions />
          <BaseCollectionTile.Swatches />
          <BaseCollectionTile.StyleSwiper />
          <BaseCollectionTile.ShopButton />
          <BaseCollectionTile.AnchorWrapper />
        </Box>
      </Box>
      <Box
        sx={{ display: { xs: 'block', md: 'none' } }}
        width="100%"
        role="article"
        aria-label={`${collection?.title || 'Collection'}`}
      >
        <Box role="region" aria-label="Collection image gallery">
          <BaseCollectionTile.ImageGallery />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingTop={{ xs: 0, sm: '16px', md: 0 }}
          role="region"
          aria-label="Collection details"
          position="relative"
        >
          <BaseCollectionTile.StyleSwiper />
          <BaseCollectionTile.Swatches />
          <Box display="flex" flexDirection="column" gap="4px">
            <BaseCollectionTile.Title />
            <BaseCollectionTile.Description />
            <BaseCollectionTile.PriceRange />
            <BaseCollectionTile.RoomOptions />
          </Box>

          <BaseCollectionTile.ShopButton />
          <BaseCollectionTile.AnchorWrapper />
        </Box>
      </Box>
    </BaseCollectionTile>
  </Box>
)

CollectionTileV2.propTypes = {
  collection: PropTypes.object.isRequired,
  featuredSlots: PropTypes.array,
  slotOrder: PropTypes.array,
}

export default CollectionTileV2
